var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 18.75H28.125V6.25H9.375V43.75H40.625V18.75ZM39.3563 15.625L31.25 7.51875V15.625H39.3563ZM7.8125 3.125H31.25L43.75 15.625V45.3125C43.75 45.7687 43.6036 46.1432 43.3109 46.4359C43.0182 46.7286 42.6437 46.875 42.1875 46.875H7.8125C7.35625 46.875 6.98177 46.7286 6.68906 46.4359C6.39635 46.1432 6.25 45.7687 6.25 45.3125V4.6875C6.25 4.23125 6.39635 3.85677 6.68906 3.56406C6.98177 3.27135 7.35625 3.125 7.8125 3.125ZM15.625 25H34.375V28.125H15.625V25ZM15.625 15.625H23.4375V18.75H15.625V15.625ZM15.625 34.375H34.375V37.5H15.625V34.375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocument);
export default __webpack_public_path__ + "static/media/ic_document.f131fcb395ce95ec8bc66eeeb12c34dc.svg";
export { ForwardRef as ReactComponent };